import Model from 'ln/model/Model';
import {Resolvable} from 'ln/components/Resolve';
import {Quiz} from './Quiz';
import {QuizQuestion} from './QuizQuestion';

export class Summary extends Model implements Resolvable{ 

    public constructor(json: object) {
        super(json);
    }

    public passed:boolean;
    public quiz:Quiz;
    public questions:QuizQuestion[];

    public getViewName(): string {
        return 'Summary';
    }

    public backToChapter(){
        // hackedihack: show the two elements that are hidden if the quiz is started
        document.getElementById('master-close-button').classList.remove('hidden');
        document.getElementById('closeChapter').classList.remove('hidden');
        this.quiz.resetQuiz();
    }


}